export const PHASE_II_ACT_ID = '30002';
export const PHASE_III_ACT_ID = '30005';
export const REWARD_INFO = [
  {
    percent: '10%',
    processTag: '+25元',
    reward: '25元',
    label: '黄金卡',
    peopleNum: 0,
    maxIncome: '134元',
    peopleText: '0~5人',
  },
  {
    percent: '15%',
    reward: '150元',
    processTag: '+150元',
    label: '白金卡',
    peopleNum: 6,
    maxIncome: '1107元',
    peopleText: '6~30人',
  },
  {
    percent: '20%',
    reward: '250元',
    processTag: '+250元',
    label: '铂金卡',
    peopleNum: 31,
    peopleText: '31~50人',
    maxIncome: '2345元',
  },
  {
    percent: '30%',
    reward: '上不封顶',
    processTag: '+≥51元',
    label: '钻石卡',
    peopleNum: 51,
    peopleText: '≥51人',
    maxIncome: '上不封顶',
  },
];

export const INVITE_STATUS_MAP = {
  success: '邀请成功',
  failed: '邀请失败',
  on_progress: '邀请进度中',
};

export const ONLINE_STATUS_MAP = {
  normal: {
    class: 'online',
    text: '昨日在线',
  },
  short_time: {
    // class: 'offline',
    class: 'error',
    text: '昨日在线时长不足',
  },
  low_bandwidth: {
    class: 'error',
    text: '昨日高峰期贡献不足',
  },
  non_x86: {
    class: 'error',
    text: '非x86(智能业务)设备',
  },
};

export const SHARE_REPORT_MAP = {
  0: 'wechat',
  1: 'moments',
  2: 'QQ',
  3: 'QQSpace',
  4: 'weibo',
  5: 'link',
  6: 'photo',
  '-1': 'cancel',
};

export const RANK_INFO = [
  {
    rank: 1,
    phone: '136****5680',
    reward: 575,
    income: 547.15,
  },
  {
    rank: 2,
    phone: '135****0409',
    reward: 245,
    income: 213.47,
  },
  {
    rank: 3,
    phone: '135****8067',
    reward: 125,
    income: 143.44,
  },
  {
    rank: 4,
    phone: '180****3344',
    reward: 90,
    income: 162.96,
  },
  {
    rank: 5,
    phone: '177****2192',
    reward: 35,
    income: 157.48,
  },
];

// 三期相关配置
// 未邀请 -- 该状态仅前端展示
export const TO_BE_INVITED_STATUS = -2;
// 全部
export const ALL_INVITE_STATUS = -1;
// 待登录
export const TO_BE_LOGGED_INVITE_STATUS = 0;
// 已完成
export const COMPLETED_INVITE_STATUS = 1;
// 待绑定
export const TO_BE_BIND_INVITE_STATUS = 2;
// 待在线达标
export const TO_BE_REACHED_INVITE_STATUS = 3;
// 已过期
export const EXPIRED_INVITE_STATUS = 4;

// 邀请好友 - 任务ID
// 注册任务
export const INVITE_TASK_REGISTRATION = '10001';
// 登录任务
export const INVITE_TASK_LOG = '10002';
// 绑定任务
export const INVITE_TASK_BIND = '10003';
// 在线达标任务
export const INVITE_TASK_REACH = '10004';
// 提现任务
export const INVITE_TASK_WITHDRAW = '10005';
// 累计邀请31个人
export const INVITE_TASK_CUMULATIVE_31 = '10006';
// 累计邀请51个人
export const INVITE_TASK_CUMULATIVE_51 = '10007';

// 邀请任务完成状态-待完成
export const INVITE_TASK_TO_BE_COMPLETED_STATUS = 0;
// 邀请任务完成状态-已完成
export const INVITE_TASK_COMPLETED_STATUS = 1;
// 邀请任务完成状态-已过期
export const INVITE_TASK_EXPIRED_STATUS = 2;

export const INVITE_TASK_BASE = [
  { taskId: INVITE_TASK_REGISTRATION, taskStatus: INVITE_TASK_TO_BE_COMPLETED_STATUS },
  { taskId: INVITE_TASK_LOG, taskStatus: INVITE_TASK_TO_BE_COMPLETED_STATUS },
  { taskId: INVITE_TASK_BIND, taskStatus: INVITE_TASK_TO_BE_COMPLETED_STATUS },
  { taskId: INVITE_TASK_REACH, taskStatus: INVITE_TASK_TO_BE_COMPLETED_STATUS },
];

export const DEFAULT_INVITE_DEEP_TASK = [
  { taskId: INVITE_TASK_CUMULATIVE_31, taskStatus: INVITE_TASK_TO_BE_COMPLETED_STATUS },
  { taskId: INVITE_TASK_CUMULATIVE_51, taskStatus: INVITE_TASK_TO_BE_COMPLETED_STATUS },
];

// 首页邀请任务映射
export const INVITE_DEEP_INVITATION_TASK = {
  [INVITE_TASK_REGISTRATION]: {
    reward: '10%加成卡',
    desc: '邀请1位好友注册即得',
    withFlag: false,
    btnText: '去分享',
  },
  [INVITE_TASK_LOG]: {
    reward: '10%加成卡',
    desc: '邀请1位好友登录app即得',
    withFlag: false,
    btnText: '去分享',
  },
  [INVITE_TASK_BIND]: {
    reward: '3元+2张30%加成卡',
    desc: '1位好友绑定有效设备最高可得',
    withFlag: true,
  },
  [INVITE_TASK_REACH]: {
    reward: '5元+30%加成卡',
    desc: '1位好友设备在线达标最高可得',
    withFlag: true,
  },
  [INVITE_TASK_CUMULATIVE_31]: {
    reward: '100元',
    desc: '累计31人完成在线达标',
    withFlag: false,
  },
  [INVITE_TASK_CUMULATIVE_51]: {
    reward: '200元',
    desc: '累计51人完成在线达标',
    withFlag: false,
  },
};

export const INVITE_STATUS_TABS = [
  {
    title: '全部',
    value: ALL_INVITE_STATUS,
  },
  {
    title: '待登录',
    value: TO_BE_LOGGED_INVITE_STATUS,
  },
  {
    title: '待绑定',
    value: TO_BE_BIND_INVITE_STATUS,
  },
  {
    title: '待在线达标',
    value: TO_BE_REACHED_INVITE_STATUS,
  },
  {
    title: '已完成',
    value: COMPLETED_INVITE_STATUS,
  },
  {
    title: '已过期',
    value: EXPIRED_INVITE_STATUS,
  },
];

export const INVITE_STATUS_TEXT_MAP = {
  [TO_BE_LOGGED_INVITE_STATUS]: '待登录',
  [TO_BE_BIND_INVITE_STATUS]: '待绑定',
  [TO_BE_REACHED_INVITE_STATUS]: '待在线达标',
  [COMPLETED_INVITE_STATUS]: '已完成',
  [EXPIRED_INVITE_STATUS]: '已过期',
};

export const INVITE_MISSION_REWARD_TEXT = {
  [TO_BE_LOGGED_INVITE_STATUS]: ['完成可得10%加成卡(7天)'],
  [TO_BE_BIND_INVITE_STATUS]: ['最高可得300云豆(≈3元)', '及30%加成卡(14天 )'],
  [TO_BE_REACHED_INVITE_STATUS]: ['最高可得500云豆(≈5元)', '及30%加成卡(14天 )'],
  [COMPLETED_INVITE_STATUS]: ['恭喜已获得奖励'],
  [EXPIRED_INVITE_STATUS]: ['不要气馁，再发起邀请吧！'],
};

export const INVITE_MISSION_INFO = {
  [INVITE_TASK_REGISTRATION]: {
    taskName: '完成注册',
    taskReward: [
      {
        reward: '10%',
        text: '加成卡(7天)',
      },
    ],
  },
  [INVITE_TASK_LOG]: {
    taskName: '登录网心云APP',
    taskReward: [
      {
        reward: '10%',
        text: '加成卡(7天)',
      },
    ],
  },
  [INVITE_TASK_BIND]: {
    taskName: '绑定第1台有效设备且在线',
    taskReward: [
      { flag: '最高', reward: '300云豆', text: '(≈3元)及' },
      {
        reward: '30%加成卡(14天)',
      },
    ],
  },
  [INVITE_TASK_REACH]: {
    taskName: '设备累计在线7天',
    taskReward: [
      {
        flag: '最高',
        reward: '500云豆',
        text: '(≈5元)及',
      },
      {
        reward: '30%加成卡(14天)',
      },
    ],
  },
  [INVITE_TASK_WITHDRAW]: {
    taskName: '首次提现',
    taskReward: [
      {
        reward: '50云豆',
        text: '(≈0.5元)及',
      },
      {
        reward: '15%加成卡(7天)',
      },
    ],
  },
};

export const SPECTIAL_INCOME_TEXT_MAP = {
  [COMPLETED_INVITE_STATUS]: '恭喜已获得奖励',
  [EXPIRED_INVITE_STATUS]: '邀请已过期',
};

export const INVITE_REWARD_TEXT_MAP = {
  [TO_BE_LOGGED_INVITE_STATUS]: '登录app可得',
  [TO_BE_BIND_INVITE_STATUS]: '绑定设备可得',
  [TO_BE_REACHED_INVITE_STATUS]: '在线达标可得',
  [COMPLETED_INVITE_STATUS]: '恭喜已得奖励',
};

export const INVITE_LEVEL_1_NUM = 1;
export const INVITE_LEVEL_1_BONUS = '10%';
export const INVITE_LEVEL_2_NUM = 6;
export const INVITE_LEVEL_2_BONUS = '15%';
export const INVITE_LEVEL_3_NUM = 31;
export const INVITE_LEVEL_3_BONUS = '20%';
export const INVITE_LEVEL_4_NUM = 51;
export const INVITE_LEVEL_4_BONUS = '30%';
export const INVITE_MAX_LEVEL = 4;
export const INVITE_LEVEL_INFO = {
  level1: {
    curLevelNum: INVITE_LEVEL_1_NUM,
    curLevelBonus: INVITE_LEVEL_1_BONUS,
    curLevelCash: 0,
  },
  level2: {
    curLevelNum: INVITE_LEVEL_2_NUM,
    curLevelBonus: INVITE_LEVEL_2_BONUS,
    curLevelCash: 0,
  },
  level3: {
    curLevelNum: INVITE_LEVEL_3_NUM,
    curLevelBonus: INVITE_LEVEL_3_BONUS,
    curLevelCash: 100,
  },
  level4: {
    curLevelNum: INVITE_LEVEL_4_NUM,
    curLevelBonus: INVITE_LEVEL_4_BONUS,
    curLevelCash: 200,
  },
};

export const DEFAULT_LEVEL_INFO = {
  curLevelNum: 0,
  curLevelBonus: 0,
  curLevelCash: 0,
};

// 邀请好友分布式奖励活动ID
export const INVITE_2023_ACT_ID = 30006;
// export const INVITE_2023_ACT_ID = 1024;

// 奖励类型 -- 现金
export const INVITE_CASH_REWARD_TYPE = 1;
// 奖励类型 -- 加成卡
export const INVITE_BONUS_REWARD_TYPE = 2;

export const INVITE_SHARE_TEXT = [
  '最近在网心云共享闲置资源赚收益，最高日赚百元，推荐给你～扫码还能领新人红包，来试试吧！',
  '最近发现闲置宽带共享可以赚网费啦，强烈推荐你了解一下！',
  '想不想不用努力就能赚点小钱？我最近在共享网络，每天最多也有十几块收入呢，付个网费足够啦，要不要了解一下？',
  '网心云最近在搞活动，简单完成几步就能领红包，还有超多加成，来赚钱啦！',
  '别说我没告诉你，我用闲置手机挂着共享网络和算力，每月能赚几百块呢，强烈推荐来试一下！',
];

export const INVITE_TASK_STATUS_TEXT_MAP = {
  [INVITE_TASK_TO_BE_COMPLETED_STATUS]: '待完成',
  [INVITE_TASK_COMPLETED_STATUS]: '已完成',
  [INVITE_TASK_EXPIRED_STATUS]: '已过期',
};

export const INVITEE_MISSION_INFO = {
  [INVITE_TASK_REGISTRATION]: {
    type: 'cash',
    rewardNum: '1元',
    desc: '完成注册当日24点前到账',
    rewardText: '奖励',
    withTag: false,
    withDesc: false,
    btnText: {
      [INVITE_TASK_COMPLETED_STATUS]: '去看看',
      [INVITE_TASK_TO_BE_COMPLETED_STATUS]: '去完成',
      [INVITE_TASK_EXPIRED_STATUS]: '去完成',
    },
  },
  [INVITE_TASK_LOG]: {
    withDesc: false,
    withTag: false,
    type: 'bonus',
    rewardNum: '50%',
    desc: '登录网心云APP可得',
    rewardText: '加成卡(14天)',
    btnText: {
      [INVITE_TASK_COMPLETED_STATUS]: '去使用',
      [INVITE_TASK_TO_BE_COMPLETED_STATUS]: '去完成',
      [INVITE_TASK_EXPIRED_STATUS]: '去完成',
    },
  },
  [INVITE_TASK_BIND]: {
    withDesc: true,
    withTag: true,
    type: 'cash',
    rewardNum: '6.4元',
    desc: '绑定首台有效设备可得',
    rewardText: '奖励及电费补贴',
    btnText: {
      [INVITE_TASK_COMPLETED_STATUS]: '去领取',
      [INVITE_TASK_TO_BE_COMPLETED_STATUS]: '去绑定',
      [INVITE_TASK_EXPIRED_STATUS]: '去绑定',
    },
  },
  [INVITE_TASK_REACH]: {
    withDesc: true,
    withTag: true,
    type: 'cash',
    rewardNum: '5元',
    desc: '有效设备在线达标可得',
    rewardText: '奖励',
    btnText: {
      [INVITE_TASK_COMPLETED_STATUS]: '去领取',
    },
  },
  [INVITE_TASK_WITHDRAW]: {
    withDesc: false,
    withTag: false,
    type: 'cash',
    rewardNum: '15%',
    desc: '首次成功提现可得',
    rewardText: '加成卡+0.5元',
    btnText: {
      [INVITE_TASK_COMPLETED_STATUS]: '去提现',
      [INVITE_TASK_TO_BE_COMPLETED_STATUS]: '去提现',
      [INVITE_TASK_EXPIRED_STATUS]: '去提现',
    },
  },
};

export const INVITE_TASK_MODAL_INFO = {
  [INVITE_TASK_BIND]: {
    title: '',
    content: [
      '什么是有效设备？',
      '1.“有效设备”是指自绑定之日起，前30天内未在线过的（仅包括玩客云/赚钱宝3代/OEC系列/三方硬件/容器魔方/赚钱宝电脑版/NAS小星/手机宝/电脑宝/OEA/x86）',
      '不符合以上要求的设备无法获得奖励哦',
      '奖励说明',
      '1、绑定奖励将在次日发放，若在绑定当日解绑设备，奖励将无法获得。（注：完成绑定后，任务状态次日更新）',
    ],
  },
  [INVITE_TASK_REACH]: {
    title: '',
    content: [
      '什么是在线达标？',
      '1.有效设备累计7天在线达标方可获得奖励；',
      '2.自绑定之日起，前7天内未在线过的设备；（单日累计在线达到5分钟即算1天）',
      '不符合以上要求的设备无法获得奖励哦',
      '*此任务奖励会在完成次日核算与发放',
    ],
  },
};

// 微信分享文案
export const SHARE_TASK_TEXT = 'hi，还差一步，就能拿到奖励啦，快去网心云看一下吧！';
// 微信分享图片
export const SHARE_TASK_IMAGE =
  'http://n.sinaimg.cn/sinakd20123/764/w1024h540/20221205/43aa-3c3382774f12a284c13c5aa4de509a2b.jpg';

export const INVITEE_HAS_DEVICE_TYPE = 'hasDevice';
export const INVITEE_USER_NO_DEVICE_TYPE = 'newuser';
export const INVITEE_OLDUSER_TYPE = 'olduser';
export const INVITEE_BIND_TYPE = [
  {
    value: INVITEE_HAS_DEVICE_TYPE,
    text: '我有设备，直接绑定',
  },
  {
    value: INVITEE_USER_NO_DEVICE_TYPE,
    text: '我是新手，为我推荐',
  },
  {
    value: INVITEE_OLDUSER_TYPE,
    text: '我是老手',
  },
];

// 邀请好友任务剩余最大展示天数，超过3天的不展示倒计时角标
export const INVITE_TASK_SHOW_MAX_REMAIND_DAY = 3;
// 需要特殊处理的任务倒计时天数 - 0天映射成“即将过期”
export const INVITE_TASK_SPECTIAL_REMAIND_DAY = 0;
// 过期/已完成的倒计时天数
export const INVITE_TASK_EXPIRED_AND_COMPLETED_REMAIN_DAY = -1;

// 未邀请的好友数据结构
export const TO_BE_INVITED_OBJ = {
  inviteStatus: TO_BE_INVITED_STATUS,
  remainDays: INVITE_TASK_EXPIRED_AND_COMPLETED_REMAIN_DAY,
};
